export const nearByTrainPosistionInfo = [
  { x: 22, y: -29, rotation: 0 },
  { x: 57, y: -14, rotation: 90 },
  { x: 71, y: 22, rotation: 0 },
  { x: 58, y: 58, rotation: 45 },
  { x: 22, y: 72, rotation: 0 },
  { x: -15, y: 58, rotation: 45 },
  { x: -29, y: 22, rotation: 0 },
  { x: -15, y: -14, rotation: 0 },
  { x: 57, y: -14, rotation: 0 },
  { x: 58, y: 58, rotation: 0 },
  { x: -15, y: 58, rotation: 0 },
  { x: -15, y: -14, rotation: 0 },
  { x: 20, y: -18, rotation: 0 },
  { x: 59, y: 22, rotation: 0 },
  { x: 20, y: 60, rotation: 0 },
  { x: -20, y: 22, rotation: 0 }
];

export const nearByTrainPosistionTable = [
  { x: 0, y: 0 },
  { x: 40, y: 20 },
  { x: 50, y: 50 },
  { x: 35, y: 85 },
  { x: 10, y: 110 },
  { x: -40, y: 85 },
  { x: -60, y: 50 },
  { x: -35, y: 15 },
  { x: 34, y: 24 },
  { x: 35, y: 85 },
  { x: -60, y: 50 },
  { x: -38, y: 27 },
  { x: -2, y: 20 },
  { x: 36, y: 60 },
  { x: -5, y: 100 },
  { x: -43, y: 60 }
];

export const tableArrowDirectionClass = [
  'up-right',
  'right-up',
  'right-bottom',
  'down-right',
  '',
  'left-bottom',
  'left-up',
  'up-left'
];

export const levelOneTerminalUIDs = [
  2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 14, 15, 16, 18, 20, 21, 23, 29, 30, 31, 33,
  37, 39, 41, 42, 43, 44, 50, 54, 55, 56, 63
];

export const levelTwoTerminalUIDs = [
  377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391,
  392, 393, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406,
  407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421,
  422, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436,
  437, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451,
  452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 462, 463, 464, 465, 466,
  467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477, 478, 479, 480, 481,
  482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493
];
